<ng-container *ngIf="template$ | async as template">
  <mat-tab-group
    [class.no-underline]="template.length === 1"
    dynamicHeight
    [dir]="currentLanguage === 'en' ? 'ltr' : 'rtl'"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab *ngFor="let templateData of template">
      <ng-template mat-tab-label
        ><h2 class="tab-title" [attr.data-testid]="getDataTestId(templateData)">
          {{ templateData.title }}
        </h2></ng-template
      >
      <div class="tab-content">
        <ng-container *ngTemplateOutlet="templateData.templateRef"></ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>
